import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Nftecosystem() {
  return (
    <section className="nft_ecosystem p-100" style={{ background: "#F8F8FB" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>NFT Ecosystem Components We Deploy</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Application Layer</h5>
                  </div>
                  <p>
                    We develop custom front-end interfaces and back-end logic
                    for NFT marketplaces, gaming applications, patent platforms,
                    and other solutions supporting NFT transactions. Our
                    solutions ensure seamless user interaction and robust
                    transaction handling.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Payment Gateways</h5>
                  </div>
                  <p>
                    We facilitate NFT payments through digital and mobile
                    wallets as well as credit cards. By offering multiple
                    payment options, we enhance user convenience and transaction
                    flexibility, ensuring a smooth and secure payment
                    experience.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Authentication Layer</h5>
                  </div>
                  <p>
                    We design and deploy self-executing smart contracts that
                    define rules for authenticating transactions between NFT
                    sellers and buyers. These contracts automate trust, reduce
                    fraud, and ensure the integrity of transactions.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Validation Layer</h5>
                  </div>
                  <p>
                    We integrate user-facing applications with blockchain
                    networks to validate NFT transactions, adding a unique hash
                    for each NFT. This process ensures the authenticity and
                    traceability of each token, enhancing security and trust.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Storage Layer</h5>
                  </div>
                  <p>
                    We implement decentralized storage networks using key-value
                    databases to store blockchain data (blocks and transactions)
                    and cloud storage for digital assets. Our solutions ensure
                    data integrity, availability, and scalability for all stored
                    digital assets.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Managing Customer Relations</h5>
                  </div>
                  <p>
                    Integrating chatbots in your sales and marketing workflows
                    saves you from memorizing important customer details and
                    carefully listening to calls. Chatbots can make
                    conversations more frequent, controlled, and engaging.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftecosystem;
